// The short summary of recent changes shown to staff at the bottom of the
// home page. Set it to { title, sections: [{ heading, items }] } when there's
// a new round of changes to share; null hides the panel.
export const STAFF_UPDATES = null;
